var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "viewMemberNotesModal",
      "modal-class": "client-details-modal",
      "centered": "",
      "size": "md",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "hide-header-close": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "view-clients-header d-flex justify-content-center align-items-center"
        }, [_c('h5', {
          staticClass: "modal-title"
        }, [_vm._v("Member Notes")]), _c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }])
  }, [_c('b-container', [_c('div', {
    staticClass: "notes-list-container"
  }, [_vm.notes.length === 0 ? _c('div', {
    staticClass: "note-item text-center text-muted rounded py-3"
  }, [_vm._v(" No notes available. ")]) : _vm._e(), _c('div', {
    staticClass: "notes-scrollable"
  }, _vm._l(_vm.sortedNotes, function (note) {
    return _c('div', {
      key: note.anID,
      staticClass: "note-item mb-3 p-3 border rounded"
    }, [_c('div', {
      staticClass: "note-content mb-2"
    }, [_vm._v(_vm._s(note.annote))]), _c('div', {
      staticClass: "d-flex justify-content-between align-items-end flex-wrap gap-2 small text-muted"
    }, [_c('div', {
      staticClass: "note-meta"
    }, [_c('div', {
      staticClass: "mb-1"
    }, [_vm._v("Added By: "), _c('strong', [_vm._v(_vm._s(note.added_by))])]), _c('div', [_vm._v("Added On: "), _c('strong', [_vm._v(_vm._s(note.created_at))])])]), note.file ? _c('div', {
      staticClass: "note-attachment"
    }, [_c('a', {
      staticClass: "doc-link",
      attrs: {
        "href": note.file,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fas fa-paperclip me-1"
    }), _vm._v("Download Attachment ")])]) : _vm._e(), note.status ? _c('div', {
      staticClass: "note-status mt-1",
      style: {
        color: _vm.getStatusColor(note.status)
      }
    }, [_vm._v(" " + _vm._s(note.status_text) + " ")]) : _vm._e()])]);
  }), 0)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }